export const formatTime = (time) => {
    return time.toUTCString();
};
